/** A soft two-note chime synthesised with WebAudio; no asset to ship, works offline. */
let ctx: AudioContext | null = null;

/** Call from a user gesture (Start) so the context is allowed to play later without one. */
export function primeAudio() {
  try { ctx ??= new AudioContext(); if (ctx.state === 'suspended') void ctx.resume(); } catch { ctx = null; }
}

export function playChime(volume = 0.25) {
  if (!ctx) primeAudio();
  if (!ctx) return;
  const t0 = ctx.currentTime;
  for (const [freq, at, len] of [[660, 0, 0.35], [880, 0.18, 0.5]] as const) {
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.type = 'sine'; osc.frequency.value = freq;
    gain.gain.setValueAtTime(0, t0 + at);
    gain.gain.linearRampToValueAtTime(volume, t0 + at + 0.02);
    gain.gain.exponentialRampToValueAtTime(0.0001, t0 + at + len);
    osc.connect(gain).connect(ctx.destination);
    osc.start(t0 + at); osc.stop(t0 + at + len + 0.05);
  }
}
